"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _colors = require("../colors");
var _CarouselSlide = _interopRequireDefault(require("./CarouselSlide"));
var _CarouselControl = _interopRequireDefault(require("./CarouselControl"));
var _CarouselIndicator = _interopRequireDefault(require("./CarouselIndicator"));
var _CarouselLoading = _interopRequireDefault(require("./CarouselLoading"));
var _CarouselFallback = _interopRequireDefault(require("./CarouselFallback"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj["default"] = obj;
    return newObj;
  }
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var THUMBNAIL_WIDTH = 70;
var getCarouselWidthForThumbs = function getCarouselWidthForThumbs(numberOfThumbs) {
  return 40 + THUMBNAIL_WIDTH * numberOfThumbs;
};
var sizeMap = {
  xs: {
    maxThumbs: 3,
    pxWidth: getCarouselWidthForThumbs(3)
  },
  s: {
    maxThumbs: 4,
    pxWidth: getCarouselWidthForThumbs(4)
  },
  m: {
    maxThumbs: 5,
    pxWidth: getCarouselWidthForThumbs(5)
  },
  l: {
    maxThumbs: 6,
    pxWidth: getCarouselWidthForThumbs(6)
  },
  xl: {
    maxThumbs: 7,
    pxWidth: getCarouselWidthForThumbs(7)
  }
};
var Carousel = /*#__PURE__*/
function (_Component) {
  _inherits(Carousel, _Component);
  function Carousel() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Carousel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Carousel)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentSlide: 0,
      previousSlide: null,
      direction: '',
      transitioning: false,
      timer: null,
      thumbsPosition: 0
    });
    _defineProperty(_assertThisInitialized(_this), "clearPendingAnimation", function () {
      if (_this.state.timer) {
        clearTimeout(_this.state.timer);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "endAnimation", function () {
      return setTimeout(function () {
        return _this.setState({
          previousSlide: null,
          transitioning: false
        });
      }, 600);
    });
    _defineProperty(_assertThisInitialized(_this), "goToNextThumbs", function () {
      _this.goToThumbs('next');
    });
    _defineProperty(_assertThisInitialized(_this), "goToPreviousThumbs", function () {
      _this.goToThumbs('prev');
    });
    _defineProperty(_assertThisInitialized(_this), "goToThumbs", function (direction) {
      var thumbsPosition = _this.state.thumbsPosition;
      var _this$props = _this.props,
        size = _this$props.size,
        children = _this$props.children;
      var totalLength = _react["default"].Children.count(children) * THUMBNAIL_WIDTH;
      var thumbsWidth = sizeMap[size].maxThumbs * THUMBNAIL_WIDTH;
      var loopPosition = direction === 'next' ? 0 : Math.floor(totalLength / thumbsWidth) * thumbsWidth * -1;
      direction === 'next' ? thumbsPosition -= thumbsWidth : thumbsPosition += thumbsWidth;
      thumbsPosition = Math.abs(thumbsPosition) >= totalLength || thumbsPosition > 0 ? loopPosition : thumbsPosition;
      _this.setState({
        thumbsPosition: thumbsPosition
      });
    });
    _defineProperty(_assertThisInitialized(_this), "goToNextSlide", function () {
      var nextSlide = _this.state.currentSlide + 1;
      if (nextSlide >= _react["default"].Children.count(_this.props.children)) {
        nextSlide = 0;
      }
      _this.goToSlide(nextSlide, 'next');
    });
    _defineProperty(_assertThisInitialized(_this), "goToPreviousSlide", function () {
      var nextSlide = _this.state.currentSlide > 0 ? _this.state.currentSlide - 1 : _react["default"].Children.count(_this.props.children) - 1;
      _this.goToSlide(nextSlide, 'prev');
    });
    _defineProperty(_assertThisInitialized(_this), "goToSlide", function (nextSlide, direction) {
      if (nextSlide === _this.state.currentSlide) {
        return;
      }
      _this.clearPendingAnimation();
      if (!direction) {
        direction = nextSlide > _this.state.currentSlide ? 'next' : 'prev'; // eslint-disable-line no-param-reassign
      }
      _this.setState(function (prevState) {
        return {
          previousSlide: prevState.currentSlide,
          currentSlide: nextSlide,
          direction: direction,
          transitioning: true,
          timer: _this.endAnimation()
        };
      }, function () {
        return _this.props.onSlideChanged && _this.props.onSlideChanged(_this.state.currentSlide);
      });
    });
    return _this;
  }
  _createClass(Carousel, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearPendingAnimation();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // eslint-disable-line camelcase
      if (nextProps.currentSlide !== this.props.currentSlide) {
        this.goToSlide(nextProps.currentSlide);
      }
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      // eslint-disable-line camelcase
      var currentSlide = this.props.currentSlide > _react["default"].Children.count(this.props.children) - 1 ? 0 : this.props.currentSlide;
      this.setState({
        currentSlide: currentSlide
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        loading = _this$props2.loading,
        size = _this$props2.size,
        pxSize = _this$props2.pxSize,
        minimal = _this$props2.minimal,
        children = _this$props2.children,
        onCarouselClick = _this$props2.onCarouselClick,
        fallbackPreview = _this$props2.fallbackPreview,
        hideIndicators = _this$props2.hideIndicators,
        showZoomOverlay = _this$props2.showZoomOverlay;
      var landscape = this.props.landscape;
      var _this$state = this.state,
        currentSlide = _this$state.currentSlide,
        previousSlide = _this$state.previousSlide,
        transitioning = _this$state.transitioning,
        direction = _this$state.direction,
        thumbsPosition = _this$state.thumbsPosition;
      var total = _react["default"].Children.count(children);
      var pixels = size && !minimal ? sizeMap[size].pxWidth : pxSize;
      var allowNavigation = minimal && total > 1 || !minimal && total > sizeMap[size].maxThumbs;
      if (minimal) {
        // just in case
        landscape = false;
      }
      var slides = _react["default"].Children.map(this.props.children, function (child, i) {
        return _react["default"].createElement(_CarouselSlide["default"], {
          active: i === currentSlide,
          index: i,
          animateOut: i === previousSlide && transitioning,
          animateIn: i === currentSlide && previousSlide !== null && transitioning,
          direction: direction,
          onCarouselClick: onCarouselClick,
          showZoomOverlay: showZoomOverlay
        }, child);
      });
      return _react["default"].createElement("div", {
        style: landscape ? {
          height: "".concat(pixels, "px"),
          display: 'flex',
          flexDirection: 'row-reverse',
          width: 'fit-content'
        } : {
          width: "".concat(pixels, "px")
        }
      }, _react["default"].createElement("div", {
        style: landscape ? {
          width: "".concat(pixels, "px")
        } : {
          height: "".concat(pixels, "px")
        }
      }, _react["default"].createElement("div", {
        className: "carousel slide"
      }, _react["default"].createElement("div", {
        className: "carousel-inner",
        role: "listbox"
      }, loading ? _react["default"].createElement(_CarouselLoading["default"], {
        size: pixels
      }) : slides && slides.length ? slides : fallbackPreview))), !hideIndicators && _react["default"].createElement("div", {
        className: "carousel-navigation".concat(minimal ? ' carousel-navigation-small' : '').concat(landscape ? ' carousel-navigation-vertical' : '')
      }, _react["default"].createElement(_CarouselControl["default"], {
        disabled: !allowNavigation,
        onClick: minimal ? this.goToPreviousSlide : this.goToPreviousThumbs,
        large: !minimal,
        direction: landscape ? 'up' : 'left',
        hintText: "Previous"
      }), _react["default"].createElement("ol", {
        className: "carousel-indicators",
        style: minimal ? {
          height: 'auto',
          overflow: 'visible'
        } : {}
      }, total && !minimal ? _react["default"].Children.map(children, function (child, i) {
        return _react["default"].createElement(_CarouselIndicator["default"], {
          slideNumber: i,
          active: currentSlide === i,
          goToSlide: _this2.goToSlide,
          offset: landscape ? {
            top: thumbsPosition
          } : {
            left: thumbsPosition
          }
        }, loading ? null : child);
      }) : minimal ? total > 0 ? _react["default"].createElement("div", null, currentSlide + 1, " / ", total) : '– / –' : _react["default"].createElement("li", {
        disabled: true,
        style: {
          backgroundColor: _colors.horizon
        }
      })), _react["default"].createElement(_CarouselControl["default"], {
        disabled: !allowNavigation,
        onClick: minimal ? this.goToNextSlide : this.goToNextThumbs,
        large: !minimal,
        direction: landscape ? 'down' : 'right',
        hintText: "Next"
      })));
    }
  }]);
  return Carousel;
}(_react.Component);
exports["default"] = Carousel;
Carousel.propTypes = {
  size: _propTypes["default"].oneOf(['xs', 's', 'm', 'l', 'xl']),
  pxSize: _propTypes["default"].number,
  minimal: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  loading: _propTypes["default"].bool,
  onCarouselClick: _propTypes["default"].func,
  currentSlide: _propTypes["default"].number,
  fallbackPreview: _propTypes["default"].node,
  landscape: _propTypes["default"].bool,
  onSlideChanged: _propTypes["default"].func,
  hideIndicators: _propTypes["default"].bool,
  showZoomOverlay: _propTypes["default"].bool
};
Carousel.defaultProps = {
  size: 'm',
  pxSize: 200,
  minimal: false,
  currentSlide: 0,
  fallbackPreview: _react["default"].createElement(_CarouselFallback["default"], null),
  landscape: false,
  hideIndicators: false,
  showZoomOverlay: false
};